/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { getGifs, getTrendingGif } from "../../../components/GIPHY";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

function SelectGif({ setExtraGif, extraGif, show, onHide, intl }) {
  const [gifs, setGifs] = useState([]);
  const [selectedGif, setSelectGif] = useState([]);
  const [inputSearch, setInputSearch] = useState("");

  const onPressGif = (gif) => {
    setSelectGif(gif);
  };

  useEffect(() => {
    trendingGif();
  }, []);

  useEffect(() => {
    if (inputSearch == "") {
      trendingGif();
    }
  }, [inputSearch]);

  const trendingGif = async () => {
    const response = await getTrendingGif();
    setGifs(response);
  };

  const searchGif = async (key) => {
    if (key) {
      const response = await getGifs(key);
      setGifs(response);
    }
  };

  const onSelect = () => {
    setExtraGif(selectedGif);
    onHide();
  };

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Modal.Header>
          <div
            class="d-flex justify-content-between align-content-center align-items-center row mt-5 mr-5 ml-5"
            style={{ width: "100%" }}
          >
            <div class="mb-2">
              <div>Select Gif</div>
            </div>
            <div class="mb-2">
              <input
                style={{ height: 38 , padding: 5}}
                class="border"
                type="text"
                placeholder="Search gif"
                value={inputSearch}
                onChange={(e) => {
                  setInputSearch(e.target.value);
                }}
              />
              <Button
                className="btn btn-icon btn-primary"
                variant="primary"
                onClick={() => searchGif(inputSearch)}
              >
                <span className="svg-icon svg-icon-md">
                  <SVG
                    height="60"
                    src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                  />
                </span>
              </Button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            class="d-flex col mb-2"
            data-spy="scroll"
            data-offset="0"
            className="containerScroll"
          >
            <div class="d-flex flex-wrap justify-content-center align-items-center mb-5">
              {gifs?.map((gif) => (
                <div
                  onClick={() => onPressGif(gif)}
                  class="mt-5 ml-5 mr-5"
                  height={175}
                  width={175}
                  style={
                    selectedGif?.id == gif?.id
                      ? {
                          border: "5px solid #94A2EE",
                        }
                      : null
                  }
                >
                  <img src={gif.url} height={175} width={175} />
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex justify-content-end mt-2">
            <div className="mr-2">
              <Button onClick={() => onHide()}>Cancel</Button>
            </div>
            <div>
              <Button onClick={() => onSelect()}> Select</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default injectIntl(SelectGif);
